import * as React from 'react';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import {WebView} from 'react-native-webview';
import ScreenContext from '../ScreenContext';
import BackSubheader from '../elements/BackSubheader';
import Styles from '../Styles';
import {StyleSheet} from 'react-native';
import Localized from 'src/constants/AppStrings';
type WebContentScreenProps = {
  url: string;
  backupUrl: string;
  title: string;
};
type WebContentScreenState = {
  url: string;
};

class WebContentScreen extends React.Component<
  WebContentScreenProps,
  WebContentScreenState
> {
  static contextType = ScreenContext;

  constructor(props: WebContentScreenProps) {
    super(props);
    this.state = {
      url: props.url,
    };
  }

  render() {
    return (
      <BackSubheader title={this.props.title}>
        <WebView
          style={styles.viewport}
          source={{
            uri: this.state.url,
          }}
          onLoadEnd={(e) => {
            if (
              e.nativeEvent.title.startsWith('404') &&
              this.props.backupUrl &&
              this.state.url !== this.props.backupUrl
            ) {
              this.setState({
                url: this.props.backupUrl,
              });
            }
          }}
        />
      </BackSubheader>
    );
  }
}

const styles = StyleSheet.create({
  viewport: {
    backgroundColor: Styles.white,
    flex: 1,
    marginHorizontal: Styles.Spacing.m1,
    paddingHorizontal: Styles.Spacing.m1,
  },
});
export default withForwardedNavigationParams()(WebContentScreen);
